import styled from '@emotion/styled';

/** iOS/Android minimum comfortable touch target; not a spacing step. */
const MOBILE_TOUCH_TARGET = 44;

export const ActionsRow = styled('div', {
  shouldForwardProp: (prop) => prop !== '$mobile',
})<{ $mobile: boolean }>(({ theme, $mobile }) => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing[8],

  // The primary label varies in length ("Continue" vs "Payment details"); letting it
  // shrink clipped the longer one inside the Actions column.
  '& > button': { flexShrink: 0 },

  ...($mobile && {
    '& > button': { minHeight: MOBILE_TOUCH_TARGET },
  }),
}));

export const MenuSlot = styled('div')({
  display: 'flex',
  flexShrink: 0,
});

export const CancelPendingState = styled('div', {
  shouldForwardProp: (prop) => prop !== '$busy',
})<{ $busy: boolean }>(({ theme, $busy }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: $busy ? `${theme.spacing[12]}px 0` : 0,
}));
